import React from 'react';

const BrandsCollaborated = () => {
  const brands = [
    { 
      name: 'Goodknight', 
      logo: 'https://customer-assets.emergentagent.com/job_rrammy-films/artifacts/47n68u9y_Goodknight%20Logo.png',
      alt: 'Goodknight by Godrej' 
    },
    { 
      name: 'Mother Dairy', 
      logo: 'https://customer-assets.emergentagent.com/job_rrammy-films/artifacts/tgi2eicx_Mother%20Dairy%20Logo.png',
      alt: 'Mother Dairy' 
    },
    { 
      name: 'Jio Hotstar', 
      logo: 'https://assets.hotstar.com/image/upload/v1656431456/web-images/logo-d-plus.svg',
      alt: 'Jio Hotstar' 
    },
    { 
      name: 'TATA Neu', 
      logo: 'https://customer-assets.emergentagent.com/job_rrammy-films/artifacts/pokf98xn_Tata%20Neu%20Logo.png',
      alt: 'TATA Neu' 
    },
    { 
      name: 'Surf Excel', 
      logo: 'https://customer-assets.emergentagent.com/job_rrammy-films/artifacts/9hxcpwvu_Surf%20Excel%20Logo.png',
      alt: 'Surf Excel' 
    },
    { 
      name: 'Jaquar', 
      logo: 'https://customer-assets.emergentagent.com/job_rrammy-films/artifacts/34pwdko8_Jaquar%20logo.png',
      alt: 'Jaquar' 
    },
    { 
      name: 'Sugar Free', 
      logo: 'https://www.zyduswellness.com/images/Sugarfree-Logo.png',
      alt: 'Sugar Free' 
    },
    { 
      name: 'Navneet', 
      logo: 'https://customer-assets.emergentagent.com/job_rrammy-films/artifacts/ur54lzhz_NAvneet%20Logo.png',
      alt: 'Navneet' 
    },
    { 
      name: 'Singleton x Nicobar', 
      logo: 'https://customer-assets.emergentagent.com/job_rrammy-films/artifacts/juunkdyf_Singleton%20Nicobar%20Logo.png',
      alt: 'Singleton Social Nicobar' 
    },
    { 
      name: 'Moi Soi', 
      logo: 'https://customer-assets.emergentagent.com/job_rrammy-films/artifacts/vjnvb7sm_Moi%20Soi%20Logo.png',
      alt: 'Moi Soi' 
    },
    { 
      name: 'iD Fresh Food', 
      logo: 'https://idfreshfood.com/wp-content/uploads/2021/09/iD-Fresh-Food-Logo.png',
      alt: 'iD Fresh Food' 
    },
    { 
      name: 'TSC - The Sleep Company', 
      logo: 'https://customer-assets.emergentagent.com/job_rrammy-films/artifacts/zu42i4na_The%20Sleep%20Company%20Logo.png',
      alt: 'TSC - The Sleep Company' 
    }
  ];

  return (
    <section className="bg-white py-20 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-light text-gray-800 mb-4">
            Brands I've Collaborated With
          </h2>
          <p className="text-gray-600 font-light">
            Creating impactful stories for leading brands across India
          </p>
        </div>

        {/* Brand Logos Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-12">
          {brands.map((brand, index) => (
            <div
              key={index}
              className="group flex items-center justify-center p-6 grayscale hover:grayscale-0 opacity-70 hover:opacity-100 transition-all duration-500 cursor-pointer"
            >
              <div className="text-center transform group-hover:scale-110 transition-transform duration-300">
                <img
                  src={brand.logo}
                  alt={brand.alt}
                  className="max-h-20 w-auto mx-auto object-contain"
                  onError={(e) => {
                    // Fallback to text if image fails to load
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'block';
                  }}
                />
                <span 
                  className="text-sm font-light text-gray-700 tracking-wide hidden"
                  style={{ display: 'none' }}
                >
                  {brand.name}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Footer Note */}
        <div className="text-center mt-16">
          <p className="text-gray-500 font-light text-sm">
            ...and many more leading brands across Television, Digital, and Cinema
          </p>
        </div>
      </div>
    </section>
  );
};

export default BrandsCollaborated;
